exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--wrap__16pQZ{max-width:940px;margin:auto}.styles--logowrap__1l-MT{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-top:14px;padding:30px 0;text-align:center}.styles--logolink__1pRyc{line-height:20px;text-decoration:none;font-family:Days, sans-serif}.styles--logo__3tGaS{font-size:24px}.styles--slogan__3_aO-{font-size:14px;letter-spacing:0.015em}.styles--logolink__1pRyc:not(:hover) .styles--logo__3tGaS span{color:inherit}\n", ""]);

// exports
exports.locals = {
	"wrap": "styles--wrap__16pQZ",
	"logowrap": "styles--logowrap__1l-MT",
	"logolink": "styles--logolink__1pRyc",
	"logo": "styles--logo__3tGaS",
	"slogan": "styles--slogan__3_aO-"
};